import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

/**
 * Parse a date string with an explicit format (strict by default).
 * @param {string} date
 * @param {string} format
 * @param {boolean} [strict=true]
 * @returns {import("dayjs").Dayjs}
 */
export const parseDateWithFormat = (date, format, strict = true) =>
  dayjs(date, format, strict);

export default parseDateWithFormat;
